<template>
    <div :class="field.classes" class="col flex-item no-padding span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp mb-2rem">
        <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
            {{ name }}
        </div>

        <div class="select-wrapper">
            <select :name="field.name"
                    @change="update"
                    :class="inputClass"
                    :v-model="localValue"
                    class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal learnworlds-element">

                <option value="" disabled selected>
                    {{ name }}
                </option>

                <option v-for="(option, index) in field.options"
                        :key="index"
                        :value="option.value">

                    {{ option.name }}
                </option>
            </select>
        </div>
        
        <div v-if="error" class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
            {{ error }}
        </div>   
    </div>
</template>

<script>
    import FieldMixin from "./FieldMixin";
    
    export default {
        name: "DropdownFieldComponent",        
        mixins: [
            FieldMixin
        ],
        data(){
            return {localValue: ''};
        },
        watch: {
            value:{
                immediate:true,
                handler(newVal){
                    this.localValue = newVal;
                }
            }
        }
    }
</script>

